var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',[_vm._v(" "+_vm._s(_vm.$t('pagination.showing'))+" "+_vm._s(_vm.from)+" "+_vm._s(_vm.$t('pagination.to'))+" "+_vm._s(_vm.to)+" "+_vm._s(_vm.$t('pagination.of'))+" "+_vm._s(_vm.total)+" "+_vm._s(_vm.$t('pagination.entries'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }